var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Current(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 60,
    viewBox: "0 0 212 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_64_1814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_64_1814",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41966 6.98456C1.89587 4.31793 3.82133 1 6.89262 1H206C208.209 1 210 2.79086 210 5V53C210 55.2091 208.209 57 206 57H6.89263C3.82134 57 1.89587 53.6821 3.41966 51.0154L14.8659 30.9846C15.5686 29.7548 15.5686 28.2452 14.8659 27.0154L3.41966 6.98456Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41966 6.98456C1.89587 4.31793 3.82133 1 6.89262 1H206C208.209 1 210 2.79086 210 5V53C210 55.2091 208.209 57 206 57H6.89263C3.82134 57 1.89587 53.6821 3.41966 51.0154L14.8659 30.9846C15.5686 29.7548 15.5686 28.2452 14.8659 27.0154L3.41966 6.98456Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8659 30.9846L13.9976 30.4884L14.8659 30.9846ZM14.8659 27.0154L13.9976 27.5116L14.8659 27.0154ZM3.41966 51.0154L2.55141 50.5193L3.41966 51.0154ZM3.41966 6.98456L2.55141 7.48069L3.41966 6.98456ZM206 0H6.89262V2H206V0ZM211 53V5H209V53H211ZM6.89263 58H206V56H6.89263V58ZM13.9976 30.4884L2.55141 50.5193L4.2879 51.5116L15.7341 31.4807L13.9976 30.4884ZM13.9976 27.5116C14.5247 28.4339 14.5247 29.5661 13.9976 30.4884L15.7341 31.4807C16.6125 29.9435 16.6125 28.0565 15.7341 26.5193L13.9976 27.5116ZM2.55141 7.48069L13.9976 27.5116L15.7341 26.5193L4.2879 6.48842L2.55141 7.48069ZM6.89263 56C4.58916 56 3.14506 53.5116 4.2879 51.5116L2.55141 50.5193C0.646681 53.8526 3.05352 58 6.89263 58V56ZM209 53C209 54.6569 207.657 56 206 56V58C208.761 58 211 55.7614 211 53H209ZM6.89262 0C3.05351 0 0.646683 4.14741 2.55141 7.48069L4.2879 6.48842C3.14506 4.48844 4.58916 2 6.89262 2V0ZM206 2C207.657 2 209 3.34315 209 5H211C211 2.23858 208.761 0 206 0V2Z",
    fill: "#00AAFF",
    mask: "url(#path-1-inside-1_64_1814)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_64_1814",
    x: 0.886719,
    y: 0,
    width: 211.113,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_64_1814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_64_1814",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Current);
export default __webpack_public_path__ + "static/media/3current.67cb86526eaa6a2f07603301d0c0e8b8.svg";
export { ForwardRef as ReactComponent };